import { atom } from "jotai";
import type { Chain } from "../lib/schemas";

export const chainAtom = atom<Chain>("avalanche");
export const feedPausedAtom = atom<boolean>(false);

export type FeedStatus = "LIVE" | "STALE" | "DEGRADED" | "UNAVAILABLE";
export const feedStatusAtom = atom<FeedStatus>("UNAVAILABLE");
export const rpcThrottledAtom = atom<boolean>(false);
